<template lang="pug">
    v-layout.pa-2(row wrap)
        v-flex(md6 xs6)
            v-icon person
            | Cajero:
        //- v-flex.informationSummaries(md6 xs6) {{openingUser}}
        v-flex.informationSummaries(md6 xs6) {{user.hr_employee.name_case}}

        v-flex(md6 xs6)
            v-icon watch_later
            | Apertura Caja:
        v-flex.informationSummaries(md6 xs6) {{openingTimeStamp}}
    
        v-flex(md6 xs6)
            v-icon attach_money
            | Monto Inicial:
        v-flex.informationSummaries(md6 xs6) ${{initialAmountCash}}
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'information-summaries',
    props: {},
    data: function(){
        return {}
    },
    computed: {
        ...mapState('AuthModule', {
            user: 'user'
        }),
        ...mapState('PaymentSummariesModule',{
            openingUser:'openingUser',
            openingTimeStamp :'openingTimeStamp',
            initialAmountCash :'initialAmountCash'
        })
    },
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>